import React from 'react';
import { T } from '../utils/themeUtils';

const IconDashboard = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect x="2" y="2" width="7" height="7" rx="1.5" stroke={color} strokeWidth="1.4"/>
    <rect x="11" y="2" width="7" height="7" rx="1.5" stroke={color} strokeWidth="1.4"/>
    <rect x="2" y="11" width="7" height="7" rx="1.5" stroke={color} strokeWidth="1.4"/>
    <rect x="11" y="11" width="7" height="7" rx="1.5" stroke={color} strokeWidth="1.4"/>
  </svg>
);

const IconBewerbungen = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect x="2" y="5" width="16" height="12" rx="2" stroke={color} strokeWidth="1.4"/>
    <path d="M7 5V4a3 3 0 016 0v1" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M6 10h8M6 13h5" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const IconSuche = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="9" cy="9" r="6" stroke={color} strokeWidth="1.4"/>
    <path d="M14 14l3.5 3.5" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const IconAnalytics = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2 15l4-5 4 3 4-7 4 3" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconProfil = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="7" r="4" stroke={color} strokeWidth="1.4"/>
    <path d="M2 18c0-4 3.6-6 8-6s8 2 8 6" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const ArrowIcon = ({ color = T.textDim }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M2 6h8M7 3l3 3-3 3" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CheckIcon = ({ color = T.accentText }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M2 6l3 3 5-6" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconBookmark = ({ filled = false, color = T.textDim }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill={filled ? color : 'none'}>
    <path d="M4 3h10a1 1 0 011 1v11l-6-3.5L3 15V4a1 1 0 011-1z"
      stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
  </svg>
);

const LinkIcon = ({ color = 'currentColor' }) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M5 8l3-3M7.5 4.5l1-1a2 2 0 012.8 2.8l-2 2a2 2 0 01-2.8 0" stroke={color} strokeWidth="1.35" strokeLinecap="round"/>
    <path d="M5.5 8.5l-1 1a2 2 0 01-2.8-2.8l2-2a2 2 0 012.8 0" stroke={color} strokeWidth="1.35" strokeLinecap="round"/>
  </svg>
);
const PdfIcon = ({ color = 'currentColor' }) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M7.5 1.5H3a1 1 0 00-1 1v8a1 1 0 001 1h7a1 1 0 001-1V5L7.5 1.5z" stroke={color} strokeWidth="1.35" strokeLinejoin="round"/>
    <path d="M7.5 1.5V5H11" stroke={color} strokeWidth="1.35" strokeLinejoin="round"/>
  </svg>
);
const TextIcon = ({ color = 'currentColor' }) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M2 4h9M6.5 4v7M4 11h5" stroke={color} strokeWidth="1.35" strokeLinecap="round"/>
  </svg>
);


const IconDokumente = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect x="3" y="5" width="11" height="13" rx="1.5" stroke={color} strokeWidth="1.4"/>
    <path d="M6 9h5M6 12h5M6 15h3" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M8 2h7a2 2 0 012 2v11" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export { IconDashboard, IconBewerbungen, IconSuche, IconAnalytics, IconProfil, IconDokumente, ArrowIcon, CheckIcon, IconBookmark, LinkIcon, PdfIcon, TextIcon };
